<div class="image-puzzle-screen" [ngClass]="{'shift-buttons-side' : shiftButtonType === 'side'}">
  <div class="image-puzzle" *ngIf="initialized">
    <div class="image-puzzle-container" #puzzleContainer>
      <div class="image-puzzle-grid"
           cdkDropListGroup [style.height.px]="scaledHeight" [style.width.px]="scaledWidth">
        <div class="image-puzzle-drop"
             [style.height.px]="scaledTileHeight" [style.width.px]="scaledTileWidth"
             *ngFor="let tile of tiles; let i = index" cdkDropList
             (cdkDropListDropped)="drop($event)"
             cdkDropListSortingDisabled
             [cdkDropListData]="tile.dropList">
          <div class="image-puzzle-drag"
               [style.height.px]="scaledTileHeight" [style.width.px]="scaledTileWidth"
               (cdkDragStarted)="onDragStart($event, i)"
               (cdkDragReleased)="onDragRelease($event)"
               [cdkDragDisabled]="disableDrag"
               cdkDrag *ngFor="let item of tile.dropList"
               [ngClass]="{wrong: highlightFields && item.tileNumber !== i, 'pointer-down': pointerDown === i}">
            <div class="drag-animation-container"
                 (mousedown)="onTileMouseDown(i)"
                 (mouseup)="onTileMouseUp()"
                 (touchstart)="onTileMouseDown(i)"
                 (touchend)="onTileMouseUp()"
                 (mousemove)="onTileMouseMove(i)"
                 (mouseleave)="onTileMouseLeave(i)"
                 [ngClass]="{'is-desktop': !hasTouchScreen, 'enable-drag': !disableDrag, 'mouse-move': mouseMove === i}">
              <img src="{{tileImages[item.tileNumber]}}"/>
              <div class="image-puzzle-overlay"></div>
            </div>

          </div>
        </div>
      </div>

      <div *ngIf="copyright" class="image-puzzle-copyright" [innerHTML]="copyright"></div>

      <div class="image-puzzle-shift handle-up" (click)="shiftUp($event)" *ngIf="shiftButtonType === 'borders'">
        <ion-button class="shift-button" fill="clear">
          <ion-icon name="chevron-up-sharp" aria-hidden="false" aria-label="Shift up"></ion-icon>
        </ion-button>
      </div>
      <div class="image-puzzle-shift handle-right" (click)="shiftRight($event)" *ngIf="shiftButtonType === 'borders'">
        <ion-button class="shift-button" fill="clear">
          <ion-icon name="chevron-forward-sharp" aria-hidden="false" aria-label="Shift up">ght</ion-icon>
        </ion-button>
      </div>
      <div class="image-puzzle-shift handle-down" (click)="shiftDown($event)" *ngIf="shiftButtonType === 'borders'">
        <ion-button class="shift-button" fill="clear">
          <ion-icon name="chevron-down-sharp" aria-hidden="false" aria-label="Shift up">wn</ion-icon>
        </ion-button>
      </div>
      <div class="image-puzzle-shift handle-left" (click)="shiftLeft($event)" *ngIf="shiftButtonType === 'borders'">
        <ion-button class="shift-button" fill="clear">
          <ion-icon name="chevron-back-sharp" aria-hidden="false" aria-label="Shift up">ft</ion-icon>
        </ion-button>
      </div>
    </div>
  </div>

  <div class="image-puzzle-footer puzzle-elevation-z3"
               *ngIf="shiftButtonType === 'bottom' || shiftButtonType === 'side'">
    <div class="image-puzzle-footer-row" style="justify-content: center">
      <ion-button class="image-puzzle-shift-button" color="primary" (click)="shiftUpPressed()">
        <ion-icon name="chevron-up-sharp" aria-hidden="false" aria-label="Shift up"></ion-icon>
      </ion-button>
    </div>
    <div class="image-puzzle-footer-row" style="justify-content: center;">
      <ion-button class="image-puzzle-shift-button" color="primary" (click)="shiftLeftPressed()">
        <ion-icon name="chevron-back-sharp" aria-hidden="false" aria-label="Shift up">ft</ion-icon>
      </ion-button>
      <ion-button class="image-puzzle-shift-button" color="primary" (click)="shiftRightPressed()" style="margin-left: 10px;">
        <ion-icon name="chevron-forward-sharp" aria-hidden="false" aria-label="Shift up">ght</ion-icon>
      </ion-button>
    </div>
    <div class="image-puzzle-footer-row" style="justify-content: center">
      <ion-button class="image-puzzle-shift-button" color="primary" (click)="shiftDownPressed()">
        <ion-icon name="chevron-down-sharp" aria-hidden="false" aria-label="Shift up">wn</ion-icon>
      </ion-button>
    </div>
  </div>

</div>
